<button class="tab" (click)="hijackOpened = !hijackOpened">
  <mat-icon inline class="tab-icon">expand_more</mat-icon>
</button>
<div class="collapser">
  <div class="main">
    <span class="message">
      You are currently working on behalf of "{{ username }}"
    </span>
    <button class="release" (click)="onClickRelease()">
      Release "{{ username }}"
    </button>
  </div>
</div>
